var React = require('react');

function MarkerFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M5.197 12.946c.866 0 5.197-4.908 5.197-7.768C10.394 2.318 8.067 0 5.197 0S0 2.318 0 5.178s4.33 7.768 5.197 7.768Zm-.001-5.178a2.594 2.594 0 0 0 2.598-2.59c0-1.43-1.163-2.589-2.598-2.589a2.594 2.594 0 0 0-2.599 2.59c0 1.43 1.163 2.589 2.599 2.589Z","clipRule":"evenodd"}));
}

MarkerFilled.defaultProps = {"fill":"none","viewBox":"0 0 11 13"};

module.exports = MarkerFilled;

MarkerFilled.default = MarkerFilled;
